import { render, staticRenderFns } from "./MarginField.vue?vue&type=template&id=186efeac"
import script from "./MarginField.vue?vue&type=script&lang=js"
export * from "./MarginField.vue?vue&type=script&lang=js"
import style0 from "./MarginField.vue?vue&type=style&index=0&id=186efeac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports